
import FulfillmentOptionComponent from './FulfillmentOption.vue';
import FulfillmentOptionLink from './FulfillmentOptionLink.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { FulfillmentType } from '../../../types/ProductDelivery';
import { Get } from 'vuex-pathify';
import { ILocalStoreJson } from '../../../types/LocalStore';
import { IProductDetailProductJson } from 'JS/types/PDP';
import { ProductSubscriptionStatus } from 'JS/types/Order';
import { useBreakpoints } from 'JS/composables/breakpoint';

@Component({
	name: 'InStorePickup',
	components: {
		FulfillmentOptionComponent,
		FulfillmentOptionLink
	}
})
export default class InStorePickup extends Vue {
	@Prop({ type: Boolean, required: false, default: false })
	readonly loading: boolean;

	/* Computed
	============================================*/
	@Get('localStore')
	readonly localStore: ILocalStoreJson;

	@Get('product')
	readonly product: IProductDetailProductJson;

	@Get('fetchingProduct')
	readonly fetchingProduct: boolean;

	@Get('selectedFulfillmentType')
	readonly selectedFulfillmentType: FulfillmentType;

	@Get('isInStockForBopus')
	readonly isInStockForBopus: boolean;

	@Get('isInStockInStore')
	readonly isInStockInStore: boolean;

	@Get('isPickupDisabled')
	readonly isPickupDisabled: boolean;

	@Get('hasSelectedVariant')
	readonly hasSelectedVariant: boolean;

	get isMobile(): boolean {
		const { isMobile } = useBreakpoints();
		return isMobile.value;
	}

 	get outOfMarket(): boolean {
		return !this.localStore;
	}

	get outOfMarketMessage(): string {
		if (this.isMobile) {
			return "To check local availability";
		} else {
			return "Set a store to check local availability";
		}
	}

	get promoText(): string | null {
		if (this.isPickupDisabled) {
			return null;
		}

		if (!this.outOfMarket && this.isInStockForBopus) {
			return 'Always FREE';
		}

		return null;
	}

	get pickupArrivalDate(): string {
		if (this.isPickupDisabled) {
			return  "Available in store";
		}

		if (!!this.product.arrivalDate) {
			return "Est. Pickup " + this.product.arrivalDate;
		}
		return this.localStore.pickupInformation.label;
	}
	
	get isSelected(): boolean {
		return this.fulfillmentOption === this.selectedFulfillmentType;
	};

	get isDisabled(): boolean {
		return this.isPickupDisabled
				|| !this.hasSelectedVariant
				|| this.fetchingProduct
				|| this.loading;
	};

	get pickupLabel(): string {
		if (this.product.liveAnimal) {
			return "In Store Pickup";
		}

		return "Drive Thru Pickup";
	}

	get mobilePickupLabel(): string {
		if (this.product.liveAnimal) {
			return "In Store";
		}

		return "Drive Thru";
	}

	get secondaryLabel(): string {
		if (this.outOfMarket) {
			return null;
		} else if (this.product.notCarriedInStore) {
			return "Not available";
		} else if (this.isInStockForBopus) {
			return this.pickupArrivalDate;
		} else if (this.isInStockInStore) {
			return "Not available";
		} else {
			return "Out of Stock";
		}
	}

	get showOrderByDisclaimer(): boolean {
		if (this.outOfMarket || this.product.notCarriedInStore) {
			return false;
		} else if (this.isInStockForBopus) {
			return !!this.product.orderByDate;
		} else {
			return false;
		}
	}

	/* Data
	============================================*/
	readonly fulfillmentOption: FulfillmentType = FulfillmentType.InStorePickup;

	/* Methods
	============================================*/

	onChange() {
		if (this.isSelected) {
			return;
		}
		this.$emit('change', this.fulfillmentOption);

		if (this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && this.product.subscriptionInfo.isDue) {
			this.$store.commit('quantity', this.product.subscriptionInfo.quantity);
		}
	}

	/* Lifecycle Hooks
	============================================*/

	created() {
		if (this.selectedFulfillmentType === FulfillmentType.InStorePickup && this.product.subscriptionInfo.status === ProductSubscriptionStatus.Active && this.product.subscriptionInfo.isDue) {
			this.$store.commit('quantity', this.product.subscriptionInfo.quantity);
		}
	}
}
